import React from 'react';
import cx from 'clsx';

import Navs from '../Navs';
import * as themeStyles from '../../assets/theme.module.scss';

const SpecTabs = ({ tabContent }) => (
    <div className={cx(themeStyles.bgGrayEee, themeStyles.pt3, themeStyles.pb3)}>
        <div className={themeStyles.container}>
            <div className={cx(themeStyles.card, themeStyles.border)}>
                <div className={themeStyles.cardBody}>
                    {tabContent.length ? <Navs tabs={tabContent} /> : null}
                </div>
            </div>
        </div>
    </div>
);

export default SpecTabs;
